import React from 'react';
import { HomePage } from './variants/home-page';
import { BrowsePage } from './variants/browse-page';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesPropertyOfTheWeek = _ref => {
  var _ref$slideType = _ref.slideType,
    slideType = _ref$slideType === void 0 ? 'home' : _ref$slideType,
    listings = _ref.listings,
    _ref$maxColumns = _ref.maxColumns,
    maxColumns = _ref$maxColumns === void 0 ? 3 : _ref$maxColumns,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Property of the Week' : _ref$title;
  var pageProps = {
    listings: listings.slice(0, maxColumns),
    onClick,
    maxColumns,
    title
  };
  switch (slideType) {
    case 'browse':
      return ___EmotionJSX(BrowsePage, pageProps);
    case 'home':
    default:
      return ___EmotionJSX(HomePage, pageProps);
  }
};
export { AllhomesPropertyOfTheWeek };